import axios from "axios";
import toast from "react-hot-toast";

export const USER_BULK_UPLOAD_REQUEST = "USER_BULK_UPLOAD_REQUEST";
export const USER_BULK_UPLOAD_SUCCESS = "USER_BULK_UPLOAD_SUCCESS";
export const USER_BULK_UPLOAD_FAILURE = "USER_BULK_UPLOAD_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;



export const uploadUserBulk = (formData) => async (dispatch) => {
  dispatch({ type: "USER_BULK_UPLOAD_REQUEST" });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/admin/bulkUserUpload`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    dispatch({
      type: "USER_BULK_UPLOAD_SUCCESS",
      payload: response.data,
    });

    toast.success("User data uploaded successfully!");
  } catch (error) {
    dispatch({
      type: "USER_BULK_UPLOAD_FAILURE",
      payload: error?.response?.data?.message || error.message,
    });

    toast.error("Upload failed!");
  }
};
